import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { RemoveCryoboxFromStagingResponse } from '../../core/api/lab.types';

export const removeCryoboxFromStagingThunk = createAsyncThunk(
  'shipment/removeCryoboxFromStaging',
  async (values: string, { rejectWithValue }: any) => {
    const response: RemoveCryoboxFromStagingResponse = await labApi.removeCryoboxFromStaging(values);
    if (response.data?.removeCryoboxFromStaging) {
      return response.data?.removeCryoboxFromStaging;
    }
    return rejectWithValue(response.errors);
  },
);
